module.exports = __webpack_public_path__ + "static/media/logo-acnh-en.e1fdea97.png";